import { render, staticRenderFns } from "./nearbyHot.vue?vue&type=template&id=9e551500&scoped=true&"
import script from "./nearbyHot.vue?vue&type=script&lang=js&"
export * from "./nearbyHot.vue?vue&type=script&lang=js&"
import style0 from "./nearbyHot.vue?vue&type=style&index=0&id=9e551500&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9e551500",
  null
  
)

export default component.exports